/**
 * ChannelsClassic – SVG icon.
 */
import Props from '@shared/types/props/pressable';
import Screen from '@screen';

/** Classic channels / grid list view. */
export default function ChannelsClassicIcon({
  focused,
  width,
  height,
  margin,
}: Props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width ? width * Screen.widthRatio : '32'}
      height={height ? height * Screen.widthRatio : '35'}
      fill='none'
      viewBox='0 0 32 35'
      style={{ margin: margin ? margin : 0 }}
    >
      <mask id='path-1-inside-1_5126_8794' fill='#fff'>
        <rect width='16.314' height='14.979' x='7.529' rx='3' />
      </mask>
      <rect
        width='16.314'
        height='14.979'
        x='7.529'
        stroke={focused ? '#000' : '#FFF'}
        strokeWidth='8'
        mask='url(#path-1-inside-1_5126_8794)'
        rx='3'
      ></rect>
      <mask id='path-2-inside-2_5126_8794' fill='#fff'>
        <rect width='16.314' height='14.979' x='7.529' y='19.064' rx='3' />
      </mask>
      <rect
        width='16.314'
        height='14.979'
        x='7.529'
        y='19.064'
        stroke={focused ? '#000' : '#FFF'}
        strokeWidth='8'
        mask='url(#path-2-inside-2_5126_8794)'
        rx='3'
      />
      <path
        fill={focused ? '#000' : '#FFF'}
        fillRule='evenodd'
        d='M0 14.979h3.275a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H0v4h2.275v6.979H0zM32 0h-3.902a3 3 0 0 0-3 3v8.979a3 3 0 0 0 3 3H32v-4h-2.902V4H32zM0 34.042h3.275a3 3 0 0 0 3-3v-8.978a3 3 0 0 0-3-3H0v4h2.275v6.978H0zM32 19.064h-3.902a3 3 0 0 0-3 3v8.978a3 3 0 0 0 3 3H32v-4h-2.902v-6.978H32z'
        clipRule='evenodd'
      ></path>
    </svg>
  );
}
